import { render, staticRenderFns } from "./activityProp.vue?vue&type=template&id=42871af8&scoped=true&"
import script from "./activityProp.vue?vue&type=script&lang=js&"
export * from "./activityProp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42871af8",
  null
  
)

export default component.exports